// This file is auto-generated

import deAT from './ottoversandat/de-AT.json';

const messages = { 'de-AT': deAT };

export default messages;
